// eslint-disable-next-line import/prefer-default-export
export function registrationTokenParam(
  registrationToken: string | null
): string {
  if (registrationToken) {
    return `?registration_token=${registrationToken}`;
  }
  return '';
}
